var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.b(),style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[_c('img',{class:_vm.b({ rotate: _vm.rotate }),style:([_vm.styleImgName, _vm.styleSizeName]),attrs:{"src":_vm.dataChart.value,"draggable":"false"}})])}
var staticRenderFns = []

export { render, staticRenderFns }